/*
  ANINA · Casas (sections/anina-casas.liquid)
  Índice de logos + palco. Com mouse: passar por cima troca a casa do palco e o clique abre a página da casa.
  No toque: o primeiro toque numa casa só a escolhe; tocar de novo na casa escolhida abre a página.
*/

class AninaCasas extends HTMLElement {
  connectedCallback() {
    this.itens = [...this.querySelectorAll('.anina-casas__item')];
    this.paineis = [...this.querySelectorAll('.anina-casas__painel')];
    this.indice = this.querySelector('[data-indice]');
    this.atual = Math.max(0, this.itens.findIndex((item) => item.classList.contains('is-ativo')));
    this.comMouse = window.matchMedia('(hover: hover) and (pointer: fine)');

    this.aoPassar = (evento) => {
      if (!this.comMouse.matches) return;
      const item = evento.target.closest('.anina-casas__item');
      if (!item) return;
      clearTimeout(this.espera);
      this.espera = setTimeout(() => this.ativar(Number(item.dataset.casa)), 80);
    };
    this.aoFocar = (evento) => {
      const item = evento.target.closest('.anina-casas__item');
      // No toque o foco chega antes do clique; só o teclado (ou o mouse) escolhe pelo foco.
      if (item && (this.comMouse.matches || item.matches(':focus-visible'))) this.ativar(Number(item.dataset.casa));
    };
    this.aoClicar = (evento) => {
      const item = evento.target.closest('.anina-casas__item');
      if (!item || this.comMouse.matches) return;
      const indice = Number(item.dataset.casa);
      if (indice === this.atual) return;
      evento.preventDefault();
      this.ativar(indice, true);
    };
    this.aoSair = () => clearTimeout(this.espera);

    this.addEventListener('pointerover', this.aoPassar);
    this.addEventListener('focusin', this.aoFocar);
    this.addEventListener('click', this.aoClicar);
    this.indice?.addEventListener('pointerleave', this.aoSair);

    // No celular, a faixa já abre mostrando a casa em destaque.
    requestAnimationFrame(() => this.centralizar(this.atual, 'auto'));
  }

  disconnectedCallback() {
    clearTimeout(this.espera);
    this.removeEventListener('pointerover', this.aoPassar);
    this.removeEventListener('focusin', this.aoFocar);
    this.removeEventListener('click', this.aoClicar);
    this.indice?.removeEventListener('pointerleave', this.aoSair);
  }

  ativar(indice, centralizar = false) {
    if (Number.isNaN(indice) || indice === this.atual) return;
    this.atual = indice;
    this.itens.forEach((item, i) => {
      const ativo = i === indice;
      item.classList.toggle('is-ativo', ativo);
      if (ativo) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
    this.paineis.forEach((painel, i) => painel.classList.toggle('is-ativo', i === indice));

    if (centralizar) this.centralizar(indice, 'smooth');
  }

  centralizar(indice, comportamento) {
    if (!this.indice || this.indice.scrollWidth <= this.indice.clientWidth) return;
    const item = this.itens[indice];
    if (!item) return;
    const deslocamento = item.getBoundingClientRect().left - this.indice.getBoundingClientRect().left;
    const alvo = this.indice.scrollLeft + deslocamento - (this.indice.clientWidth - item.offsetWidth) / 2;
    this.indice.scrollTo({ left: alvo, behavior: comportamento });
  }
}

if (!customElements.get('anina-casas')) customElements.define('anina-casas', AninaCasas);